import { useState, useRef, useCallback } from 'react';

import EditDrawer from './EditDrawer';
import Operator from '../../components/Operator';
import DataTable from '../../components/DataTable';
import AvatarName from '../../components/AvatarName';
// import ImportButton from '../../components/ImportButton';
// import AddDataButton from '../../components/AddDataButton';
import SideNav from '../../components/SideNav';
import PageTransition from '../../components/PageTransition';

export default function Referee() {
  const [editDrawerVisible, setEditDrawerVisible] = useState(false);
  const dataTableRef = useRef(null);

  const reloadData = useCallback(() => {
    if (dataTableRef.current?.refresh) {
      dataTableRef.current.refresh();
    }
  }, []);

  const options = [
    { value: 'name', label: '裁判姓名' },
    { value: 'phone', label: '裁判手机号' },
    { value: 'certificate', label: '证件号' },
  ];
  const columns = [
    {
      title: '裁判名称',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <AvatarName name={text} avatar={record.avatar} />
      ),
    },
    {
      title: '联系方式',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: '身份证号',
      dataIndex: 'idCard',
      key: 'idCard',
    },
    {
      title: '证件号',
      dataIndex: 'certificate',
      key: 'certificate',
    },
    {
      title: '所在城市',
      dataIndex: 'cityName',
      key: 'cityName',
    },
    {
      title: '操作',
      key: 'action',
      align: 'right',
      render: (_, record) => (
        <Operator
          removeAPI="/events/admin/referee/invite"
          onRemove={() => {
            if (dataTableRef.current?.refresh) {
              dataTableRef.current.refresh();
            }
          }}
          title="裁判"
          record={record}
        />
      ),
    },
  ];

  return (
    <PageTransition>
      <SideNav />
      <main className="flex-1">
        <div className="bg-white rounded-xl shadow-sm p-6 space-y-5 container mx-auto">
          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex justify-between gap-3 bg-slate-50 border border-slate-200 rounded-xl p-4 h-full">
                <div className="flex-1">
                  <p className="text-base font-semibold text-slate-900 text-left">
                    从平台库添加裁判
                  </p>
                  <p className="text-xs text-slate-600 text-left">
                    直接从平台裁判库挑选，快速添加裁判
                  </p>
                </div>
                <AddDataButton
                  type="referee"
                  api="/events/admin/referee/list"
                  onSuccess={handleImportSuccess}
                />
              </div>

              <div className="flex justify-between gap-3 bg-amber-50 border border-amber-200 rounded-xl p-4 h-full">
                <div className="flex-1">
                  <p className="text-base font-semibold text-slate-900 text-left">
                    导入裁判
                  </p>
                  <div className="text-xs text-slate-700 text-left">
                    <span>
                      导入裁判意味着您将裁判加入平台裁判库，平台将自动为裁判创建一个小程序工作台。
                    </span>
                    <a
                      className="text-blue-400"
                      href="https://statics.dronex.cc/template/%E5%AF%BC%E5%85%A5%E8%A3%81%E5%88%A4%E6%A8%A1%E6%9D%BF.xlsx"
                    >
                      下载示例
                    </a>
                  </div>
                </div>
                <ImportButton
                  api="/events/referee/import"
                  onSuccess={handleImportSuccess}
                />
              </div>
            </div> */}
          <DataTable
            ref={dataTableRef}
            options={options}
            onCreate={() => setEditDrawerVisible(true)}
            columns={columns}
            api="/events/admin/referee/invite/list"
            // addType="referee"
          />
          <EditDrawer
            open={editDrawerVisible}
            onClose={() => {
              setEditDrawerVisible(false);
            }}
            onSave={reloadData}
          />
        </div>
      </main>
    </PageTransition>
  );
}
